/**
 * Parses an expert `identifier` field from the authority_ui_metadata backend response
 * into a raw Atlassian accountId.
 *
 * Supported formats:
 *   - ARI:       `ari:cloud:identity::user/{accountId}`
 *   - Bare:      `{accountId}` (contains a colon, e.g. `712020:abc-123`)
 *   - accountId prefix: `accountId:{accountId}`
 *
 * Returns `null` for unrecognised/malformed identifiers (e.g. bare slugs like `MCB`).
 */
export function parseExpertIdentifier(identifier: string | undefined | null): string | null {
	if (!identifier) {
		return null;
	}

	// ARI format: ari:cloud:identity::user/{accountId}
	const ariMatch = identifier.match(/^ari:cloud:identity::user\/(.+)$/);
	if (ariMatch) {
		const accountId = ariMatch[1];
		return accountId ? accountId : null;
	}

	// accountId: prefix format: accountId:{accountId}
	if (identifier.startsWith('accountId:')) {
		const accountId = identifier.slice('accountId:'.length);
		return accountId ? accountId : null;
	}

	// Bare accountId format — must contain a colon but NOT start with `ari:` (e.g. `712020:abc-123`)
	// Slugs like `MCB` have no colon and are unresolvable.
	// ARIs that didn't match the user pattern above are rejected.
	if (identifier.includes(':') && !identifier.startsWith('ari:')) {
		return identifier;
	}

	return null;
}
